import { render, staticRenderFns } from "./typeItemsList.vue?vue&type=template&id=b3f67e84&scoped=true&"
import script from "./typeItemsList.vue?vue&type=script&lang=js&"
export * from "./typeItemsList.vue?vue&type=script&lang=js&"
import style0 from "./typeItemsList.vue?vue&type=style&index=0&id=b3f67e84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f67e84",
  null
  
)

export default component.exports